import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';

function useFormFieldWatch(control, fields, callback) {
  const changesList = useWatch({ control, name: fields });
  return useMemo(() => callback(changesList), [changesList]);
}

export default useFormFieldWatch;
